export const en = {
  'common.language': 'Language',
  'common.environment': 'Environment',
  'is.reachable': 'is reachable',
  'is.not.reachable': 'is not reachable',
  'not.found.message': 'This page does not exist.',
  'common.back': 'Back',
  'an.error.occurred': 'An error occurred',
  'common.back-office': 'Back-office',
  'common.french': 'French',
  'common.english': 'English',
  'common.routing.game-mechanics': 'Game mechanics',
  'common.routing.dialog': 'Dialogs',
  'common.routing.image': 'Image click',
  'common.routing.multiple-choice': 'Multiple choice questions',
  'common.routing.reorder': 'Reorder',
  'common.routing.single-choice': 'Single choice questions',
  'common.routing.users': 'Users',
  'common.routing.files': 'Files',
  'common.routing.statistics': 'Statistics',
  'theme.dark': 'Dark mode',
  'theme.light': 'Light mode',
  'common.logout': 'Logout',
  'common.users': 'Users',
  'common.files': 'Files',
  'common.administration': 'Administration',
  'common.menu': 'Menu',
  'file-upload.success': 'File uploaded successfully.',
  'file-upload.failed': 'File upload failed.',
  'no.files': 'No files.',
  'start-by-uploading-a-file-using-the-button-below': 'Start by uploading a file using the button below.',
  'common.email': 'Email address',
  'common.firstname': 'First name',
  'common.lastname': 'Last name',
  'common.role': 'Role',
  'common.lastConnection': 'Last connection',
  'status.active': 'Active',
  'status.pending': 'Pending',
  'common.search': 'Search',
  'common.add': 'Add',
  'common.export': 'Export',
  'common.status': 'Status',
  'common.action': 'Actions',
  'common.update': 'Update',
  'common.delete': 'Delete',
  'common.impersonate': 'Impersonate',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'good.update.user': 'User update was successful.',
  'bad.update.user': 'Failed to update user.',
  'update.user': 'Update user',
  'input.required.message': 'This field is required',
  'input.email.message': 'Enter your email address!',
  'common.cancel': 'Cancel',
  'good.delete.user': 'User was successfully deleted.',
  'bad.delete.user': 'Failed to delete user.',
  'delete.user': 'Delete user',
  'delete.user.first-message': 'Deleting this user will delete all their statistics and access.',
  'delete.second-message': 'Are you sure?',
  'good.add.user': 'User was successfully added.',
  'bad.add.user': 'Failed to add user.',
  'create.user': 'Create user',
  'common.create': 'Create',
  'common.home': 'Home',
  'common.mechanics': 'Mechanics',
  'quiz.result.title': 'Quiz result',
  'quiz.result.questions': 'Correct answers',
  'quiz.result.failure': 'You failed the quiz',
  'quiz.result.success': 'You passed the quiz',
  'quiz.restart': 'Restart',
  'time.left': 'Time left',
  'quiz.question': 'Question',
  'quiz.answer.correct': 'Correct answer',
  'quiz.answer.incorrect': 'Incorrect answer',
  'common.validate': 'Validate',
  'common.finish': 'Finish',
  'messages-history': 'Message history',
  'no.history.infos': 'No history',
  'reset.password.success': 'A reset email has been sent',
  'bad.reset.message': 'Failed to send the reset email.',
  'bad.server-login.message': 'Unable to contact the server!',
  'common.loading': 'Loading',
  'reset.password': 'Reset Password',
  'common.submit': 'Submit',
  'login.return-message': 'Return to login page',
  'input.password': 'Enter your password!',
  'password.not-match.message': 'Passwords do not match',
  'new.password.success': 'Your password has been updated',
  'new.password': 'New Password',
  'new.password.description': 'Enter your new password',
  'common.password': 'Password',
  'common.results': 'results',
  'common.confirm-password': 'Confirm Password',
  'logout.redirect.message': 'Logout successful! Redirecting in',
  'login.microsoft': 'Login with Microsoft',
  'impossible.read.token': 'Unable to read token!',
  'connection.successful': 'Connection successful!',
  'connection.failed': 'Connection failed!',
  'common.login': 'Login',
  'password.forgot': 'Forgot password?',
  'have-account.message': 'Don\'t have an account?',
  'common.register': 'Register',
  'access.denied.message': 'You do not have access rights to this page.',
  'input.password-confirm': 'Confirm your password',
  'good.register.message': 'Registration was successful.',
  'bad.register.message': 'Registration failed.',
  'finish.register': 'Finish registration',
  'password.confirm': 'Confirm your password',
  'good-order.message': 'The correct order is:',
  'reset.password.description': 'Enter your email address to reset your password',
  'common.login.description': 'Enter your email and password below to login to your account',
  'finish.register.message': 'Enter your email, first name, last name, and password to complete your registration.',
  'good.reset.message': 'The reset email has been sent successfully.',
  'new.password.confirm': 'Confirm New Password',
  'create.account': 'Create Account',
  'create.account.description': 'Enter your information to create an account',
  'create.account.success': 'Your account has been created successfully',
  'first.name': 'First Name',
  'last.name': 'Last Name',
  'reset.password.message': 'Enter your email address to reset your password.',
  'new.password.message': 'Enter your email address and new password',
  'common.ok': 'Valid',
  'common.game-mechanics': 'Game mechanics',
  'quiz-mechanisms.available': 'Available quiz mechanics',
  'common.welcome': 'Welcome',
  'no.content': 'No content',
  'common.confirm': 'Confirm',
  'common.reset': 'Reset',
  'common.empty': 'No data',
  'desc.sort': 'Click to sort in descending order',
  'asc.sort': 'Click to sort in ascending order',
  'cancel.sort': 'Click to cancel sorting',
  'your.informations': 'Your information',
  'you.are': 'You are',
  'your.email': 'Your email',
  'token.creation.message': 'Your token was created on:',
  'token.expiration.message': 'Your token will expire on:',
  'common.hello': 'Hello',
  'user.management': 'User management',
  'add.user': 'Add user',
  'bad.connection': 'Unable to connect',
  'bad.connection.message': 'The password and email entered do not match. Please check your information and log in again.',
  'common.close': 'Close',
  'common.quiz-mechanics': 'Quiz mechanics',
  'mechanisms.available': 'Available mechanics',
  'import.user': 'Import user',
  'good.import.user': 'User import was successful.',
  'bad.import.user': 'Failed to import user.',
  'download.template': 'Download template',
  'click.to.upload': 'Click to upload',
  'common.import': 'Import',
  'common.settings': 'Settings',
  'unknow.error': 'Unknown error!',
  'common.dashboard': 'Dashboard',
  'impersonate.user': 'Impersonate user',
  'bad.impersonate.user': 'Failed to impersonate user.',
  'impersonate.user.first-message': 'Impersonating this user will allow you to log in on their behalf.',
  'impersonate.user.second-message': 'You will be logged out.',
  'account.validate': 'Validate account',
  'account.validate.confirmation': 'Please confirm your account by clicking the button below.',
  'valid.account.success': 'Your account has been successfully validated!',
  'valid.account.failed': 'Account validation failed. Please try again later.',
  'resend.email.success': 'Validation email sent successfully',
  'resend.email.failed': 'Failed to send validation email',
  'resend.email': 'Resend validation email',
  'scorm.player.title': 'SCORM Module',
  'scorm.player.loading': 'Loading module...',
  'scorm.player.error': 'Error loading SCORM module',
  'scorm.progress.saved': 'Progress saved',
  'scorm.progress.save.error': 'Error saving progress',
  'common.statistics': 'Statistics',
  'common.completionStatus': 'Completion Status',
  'common.successStatus': 'Success Status',
  'common.score': 'Score',
  'common.completedAt': 'Completed At',
  'common.totalTime': 'Total Time',
  'status.completed': 'Completed',
  'status.incomplete': 'Incomplete',
  'status.not_attempted': 'Not Started',
  'status.unknown': 'Unknown',
  'status.passed': 'Passed',
  'status.failed': 'Failed',
  'login.sso': 'SSO Login',
  'sso.error': 'SSO login error',
}
